export const getProductReviewBreadcrumbs = (companyName?: string) => [
  {
    label: "Compras",
    href: companyName ? `/${companyName}/mis-compras/lista` : "/mis-compras/lista",
  },
  {
    label: "Estado de la compra",
  },
];